var map = {
	"./Approve.svg": "904c",
	"./EEF_RGB_UA_trnsp.png": "4a1e",
	"./EU_Phoenix Program_logo_crvFN-01.png": "faee",
	"./Oval.svg": "7046",
	"./activate.svg": "5b38",
	"./any.svg": "ec3d",
	"./beds.svg": "f192",
	"./bell.png": "aefd",
	"./btc.svg": "3659",
	"./building.svg": "2a26",
	"./coins.png": "0621",
	"./copy.svg": "87d1",
	"./days.svg": "4ff1",
	"./dmytro-pryadko.jpeg": "9b88",
	"./dobrobat.png": "2d39",
	"./dot.svg": "2245",
	"./empty.svg": "0afe",
	"./entire_house.svg": "a8ea",
	"./eth.svg": "b4ad",
	"./eye.svg": "9be9",
	"./fora.svg": "c887",
	"./forward_together.png": "81cc",
	"./founders-five.png": "50e4",
	"./founders-four.png": "9f97",
	"./founders-one.png": "eb82",
	"./founders-six.png": "a65d",
	"./founders-three.png": "5672",
	"./founders-two.png": "8f42",
	"./fullmap.png": "5b63",
	"./gov-sites.svg": "7ce1",
	"./halyna_yanchenko.jpg": "6869",
	"./headphones.png": "8f44",
	"./heart.png": "4cb0",
	"./hero.webp": "07be",
	"./home-1.png": "34d9",
	"./home.svg": "e3e6",
	"./kabmin.svg": "0ae6",
	"./logo.png": "4ffd",
	"./logo_ua.svg": "6214",
	"./man-edit-account.svg": "7b4c",
	"./map.png": "48dd",
	"./messages.png": "dec7",
	"./min-integration.svg": "5715",
	"./min_reintegration.png": "aa2a",
	"./min_restore.png": "087a",
	"./minregion.png": "fdd2",
	"./minregion_small.png": "ac1a",
	"./mti.gif": "8962",
	"./nights.svg": "3a96",
	"./pencil.svg": "2d07",
	"./people.svg": "6b3b",
	"./red-heart-icon.svg": "43bb",
	"./room.svg": "4597",
	"./shield.png": "4970",
	"./star.png": "ba5a",
	"./star.svg": "d8e7",
	"./telegram.svg": "7315",
	"./telegram_icon.svg": "d531",
	"./trash.svg": "5665",
	"./trident.svg": "8cb7",
	"./ukraine.png": "02e6",
	"./ukraine.svg": "29af",
	"./ukraine_now.png": "37c9",
	"./unactivate.svg": "acc7",
	"./unhcr.png": "c851",
	"./usdt.svg": "45e4",
	"./victory.svg": "57cb",
	"./weeks.svg": "dab1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";